import * as React from "react";
import { forwardRef } from "react";
const SvgHome = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.99988 11.8571L14.1649 2L26.3299 11.8571V25H16.4358V16.8824H11.8939V25H1.99988V11.8571Z" }));
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
